/**
 *
 * @param {Date=} date
 * @returns {Date}
 */
const toUtc = (date = new Date()) => new Date(new Date(date).toLocaleString('en-US', { timeZone: 'UTC' }));

export default toUtc;
